import { createContext } from "react"
import { defaultCollectionContextValue } from "./defaultCollectionContextValue"
import type { CollectionContext } from "src/types"

export const UserEventsCollectionContext: CollectionContext = createContext(
  defaultCollectionContextValue,
)
